"use strict"

import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import { withFermManagementConfig } from "../../../config/FermManagementConfigProvider"
import StartEditRunButton from "../modals/StartRunModal/StartEditRunButton"
import StopRunButton from "../modals/StopRunModal/StopRunButton"
import RunTable from "./RunTable"
import FiltersEditor from "../../../shared_components/table_filter_editor/FiltersEditor"
import { handleRunFilters } from "../../../shared_components/table_filter_editor/utils"
import { RunInfoPopover } from "../../shared_components_registration_overflow"

function RunManagement({
  //FermManagementConfigProvider
  loadData,
  filterRuns: runs = [],
  filterLoading: loading = false,
  filterRunErr: error,
  getFilteredRuns,
  setAddEditRunWarn,
  IS_PROJECT_EXPERIMENT_SITE = false,
  experiments = [], // To watch and, on change, trigger a reload of filter options
  //--FermManagementConfigProvider
  intl,
}) {
  const [selectedRun, setSelectedRun] = useState(null)
  const [queryUrl, setQueryUrl] = useState("")
  const [storedFilters, setStoredFilters] = useState([])
  const disabled = !!(loading || error)
  useEffect(() => {
    queryUrl && getFilteredRuns(queryUrl)
  }, [queryUrl])

  const resetState = () => {
    setAddEditRunWarn(false)
    setSelectedRun(null)
  }
  const resetStateAndReloadData = () => {
    resetState()
    loadData()
    getFilteredRuns(queryUrl)
  }
  const startEditStopProps = {
    onHide: resetState,
    onSuccess: resetStateAndReloadData,
    intl: intl,
  }

  return (
    <div style={{ display: "relative" }}>
      <hr />
      <div className={"row"} style={{ marginTop: "30px", marginBottom: "15px" }}>
        <div className={"row col-10"}>
          <div
            className={"col-md-3 solid-grey-border-r"}
            style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}
          >
            <StartEditRunButton
              {...startEditStopProps}
              onBtnClick={resetState}
              isUpdate={!!selectedRun?.id}
              disabled={disabled}
              run={selectedRun}
              type={"add"}
            />
            <StartEditRunButton
              {...startEditStopProps}
              isUpdate={false}
              disabled={disabled || !selectedRun?.id}
              run={selectedRun}
              type={"duplicate"}
            />
          </div>
          <div className={"col-md-9"}>
            <FiltersEditor
              disabled={loading}
              onSearch={(filters) => {
                setStoredFilters(filters)
                const filterString = Object.entries(handleRunFilters(filters))
                  .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                  .join("&")
                setQueryUrl(filterString ? `/warehouse/runs/?${filterString}` : "/warehouse/runs/")
              }}
              intl={intl}
              expProjectChange={experiments}
              includeActiveFilter
              isRunView
            />
          </div>
        </div>
        <div className={"col-2"}>
          <Button
            variant={"outline-primary"}
            onClick={(e) => {
              e.preventDefault()
              loadData()
              getFilteredRuns(queryUrl)
            }}
            disabled={disabled}
            style={{ float: "right" }}
          >
            <i className={"fa fa-refresh"} style={{ marginRight: "2px" }} />
            &nbsp;
            <span>{intl.formatMessage({ id: "general.refresh", defaultMessage: "Refresh" })}</span>
          </Button>
        </div>
      </div>
      <div style={{ overflowX: "scroll" }}>
        <RunTable
          runs={runs}
          loading={loading}
          error={error}
          reloadData={resetStateAndReloadData}
          actionHeader={{
            Header: <FormattedMessage id={"general.action"} defaultMessage={"Action"} />,
            id: "actions",
            disableSortBy: true,
            notCentered: true,
            style: { width: "130px", padding: "5px" },
            accessor: (run) => {
              return (
                <div style={{ display: "flex", flexDirection: "column", fontSize: "90%" }}>
                  {run.status !== "Archiving" ? (
                    <>
                      <RunInfoPopover run={run} intl={intl} onHide={resetState} />
                      <StopRunButton {...startEditStopProps} run={run} />
                      <StartEditRunButton
                        {...startEditStopProps}
                        isUpdate={!!run?.id}
                        disabled={disabled}
                        run={run}
                        type={"edit"}
                        small={true}
                      />
                    </>
                  ) : (
                    <span>
                      {intl.formatMessage({ id: "general.stopping", defaultMessage: "Stopping" })}...
                    </span>
                  )}
                </div>
              )
            },
          }}
          setSelectedRun={setSelectedRun}
          selectedRun={selectedRun}
          live={queryUrl.includes("active__exact=Yes")}
          intl={intl}
          pageSize={30}
          filters={storedFilters}
          showExperiments={IS_PROJECT_EXPERIMENT_SITE}
        />
      </div>
    </div>
  )
}

export default withFermManagementConfig(RunManagement)
